import { api } from 'shared/api';
import { Country } from 'entities/countries/model/types';
import { ApiResponse } from 'shared/model/types';

const countriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCountries: build.query<ApiResponse<Array<Country>>, { enroll?: boolean } | void>({
      query: ({ enroll } = {}) => ({
        url: '/open/country',
        method: 'GET',
        params: { enroll },
      }),
    }),
    checkIpProhibited: build.query<ApiResponse<unknown>, void>({
      query: () => ({
        url: '/open/country/check-ip-prohibited',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCountriesQuery, useCheckIpProhibitedQuery } = countriesApi;

export default countriesApi;
